<template>
  <div class="Main">
    <Header class="Header" />
    <Menu class="Menu" />
    <!-- <Breadcrumb class="Breadcrumb" /> -->
    <div class="Content">
      <router-view v-slot="{ Component, route }" class="router-view">
        <PageTransition>
          <component :is="Component" :key="route.path" />
        </PageTransition>
      </router-view>
    </div>
  </div>
</template>

<script setup>
import Header from "@/components/Layout/Header";
import Menu from "@/components/Layout/Menu";
import Breadcrumb from "@/components/Layout/Breadcrumb";
import { computed, provide } from "vue";
import { local } from "@/utils/storage.js";

const USERINFO = computed(() => {
  return {
    userName: local.get("userName"),
    userId: local.get("id"),
  };
});

provide("USERINFO", USERINFO);
</script>

<style scoped lang="scss">
.Main {
  width: 100vw;
  height: 100vh;
  display: grid;
  grid-template-columns: auto 1fr;
  // grid-template-rows: 100px 35px 1fr;
  grid-template-rows: 100px 1fr;
  overflow: hidden;
  // "Menu Breadcrumb"
  grid-template-areas:
    "Header Header"
    "Menu Content"
    "Menu Content";
  background: url('../assets/images/home-bg.png') no-repeat;
  background-size: 100% 100%;
  .Header {
    grid-area: Header;
    box-shadow: 0 3px 10px 1px rgba(0, 104, 163, 0.1);
    z-index: 3;
  }

  .Menu {
    grid-area: Menu;
    box-shadow: 3px 0 6px 1px rgba(0, 104, 163, 0.1);
    z-index: 2;
    overflow: auto;

    &::-webkit-scrollbar {
      display: none;
    }

    ul {
      height: 100%;
    }
  }

  .Breadcrumb {
    // grid-area: Breadcrumb;
    box-shadow: 0 3px 10px 1px rgba(0, 104, 163, 0.1);
    z-index: 1;
    //overflow-y: hidden;
    //overflow-x: auto;
  }

  .Content {
    width: 100%;
    height: 100%;
    grid-area: Content;
    overflow: hidden;
    padding: 15px;

    .router-view {
      width: 100%;
      min-height: 80vh;
      max-height: 100%;
      padding: 30px;
      background: url('@/assets/svgs/biaoge_bg.svg#svgView(preserveAspectRatio(none))') no-repeat;
      background-size: 100% 100%;
      overflow: auto;
    }
  }
}
</style>
